import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-right",
  "use": "icon-arrow-right-usage",
  "viewBox": "0 0 12 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 20\" id=\"icon-arrow-right\"><path d=\"M11.414 8.586l-8-8A2 2 0 10.586 3.414L7.172 10 .586 16.586a2 2 0 102.828 2.828l8-8a2 2 0 000-2.828\" fill=\"#CCC\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol